import type { CSSProperties, ReactNode } from "react";

import { isDemoMode } from "../demo/demoMode";

// Blurs free-text / AI content in demo mode while keeping the surrounding
// layout visible ("show structure, blur content"). Used for the unstructured
// prose that the data-layer anonymiser can't reliably scrub: AI traces,
// conversation messages, run decision narrative, document-extracted facts, the
// procurement tab. Outside demo mode it renders children untouched.
//
// pointer-events:none + user-select:none stop casual reveal (selecting,
// clicking through). NB this is visual only - the text is still in the DOM, so
// it is recoverable via devtools; acceptable for an on-stage demo (see
// docs/Y2026-Q2/design-demo-mode.md "Known limitations").
export const DemoBlur = ({
  children,
  inline,
  blurPx = 5,
}: {
  children: ReactNode;
  inline?: boolean;
  blurPx?: number;
}) => {
  if (!isDemoMode()) return <>{children}</>;
  const style: CSSProperties = {
    filter: `blur(${blurPx}px)`,
    userSelect: "none",
    pointerEvents: "none",
    ...(inline ? { display: "inline-block" } : {}),
  };
  return (
    <span
      style={style}
      aria-hidden
      title="Content hidden in demo mode"
      data-demo-blur
    >
      {children}
    </span>
  );
};

export default DemoBlur;
